import Vue from 'vue';

    import storeCEM from '@/hotelcem/store/index'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
export const asyncRoutes = [
  // 首页
  {
    name: 'HOTEL-CEM-HOME',
    path: '/home',
    meta: {
      title: $t('c0bc31'),
    },
    component: () =>
      import(
        /* webpackPreload: true, webpackMode: 'eager', webpackChunkName: 'home' */ '@/hotelcem/views/home-new/index.vue'
      ),
  },
  // 老首页
  {
    name: 'HOTEL-CEM-HOME-CEM',
    path: '/home-cem',
    meta: {
      title: '首页',
    },
    component: () =>
      import(/* webpackPreload: true, webpackMode: 'eager', webpackChunkName: 'home' */ '@hotelcem/views/home/Home'),
  },
  // 预警系统
  {
    name: 'WARNING-SYSLYSIS-INDEX',
    path: '/warning-system',
    redirect: '/warning-system/warning-analysis',
    meta: {
      title: '住中语音',
    },
    component: () => import('@hotelcem/views/warning-system/index'),
    children: [
      // 语音分析
      {
        name: 'VOICE-ANALYSIS-INDEX',
        path: '/voice-analysis/index',
        meta: {
          title: '语音分析',
          voiceType: 'OVERVIEW',
        },
        // name: 'CALL-OVERVIEW-INDEX',
        // path: '/call-overview/index',
        // meta: {
        //   title: '整体服务',
        // },
        // 语音分析
        component: () => import('@/hotelcem/views/voice-analysis/call-overview/index.vue'),
        props: { device: storeCEM.getters.deviceMode },
      },
      // 客诉分析
      {
        name: 'WARNING-SYSTEM-WARNING-ANALYSIS',
        path: '/warning-system/warning-analysis',
        meta: {
          title: '客诉分析',
          voiceType: 'COMPLAINT',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/voice-analysis/call-overview/index'),
      },
      {
        name: 'WARNING-SYSTEM-WARNING-ANALYSIS-GROUP',
        path: '/warning-system/warning-analysis-group',
        meta: {
          title: '集团客诉分析',
          voiceType: 'COMPLAINT',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/voice-analysis/call-overview/index-group'),
      },
      // 语音记录
      {
        name: 'VOICE-ANALYSIS-DEMAND-DETAIL',
        path: '/voice-analysis/demand-detail',
        meta: {
          title: '语音记录',
          voiceType: 'ALL',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@hotelcem/views/warning-system/warning-record/index'),
      },
      // 客诉记录
      {
        name: 'WARNING-SYSTEM-WARNING-RECORD',
        path: '/warning-system/warning-record',
        meta: {
          title: '客诉记录',
          voiceType: 'COMPLAINT',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@hotelcem/views/warning-system/warning-record/index'),
      },
      // 平台投诉
      {
        name: 'WARNING-SYSTEM-COMPLAINT-RECORD',
        path: '/warning-system/complaint-record',
        meta: {
          title: '平台投诉',
          voiceType: 'COMPLAINT',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@hotelcem/views/warning-system/complaint-record/index'),
      },
      // 语音记录详情
      {
        name: 'WARNING-SYSTEM-WARNING-RECORD-DETAIL-NORMAL',
        path: '/voice-system/record-detail',
        meta: {
          title: '详情',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/warning-system/warning-record/record-detail'),
      },
      // 客诉记录详情
      {
        name: 'WARNING-SYSTEM-WARNING-RECORD-DETAIL',
        path: '/warning-system/record-detail',
        meta: {
          title: '详情',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/warning-system/warning-record/record-detail'),
      },
      // 线下客诉列表
      {
        name: 'CUSTOM-WARNING-LIST',
        path: '/custom-warning/list',
        meta: {
          title: '线下客诉',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/warning-system/custom-warning/index.vue'),
      },
      // 线下客诉详情
      {
        name: 'CUSTOM-WARNING-DETAIL',
        path: '/custom-warning/detail',
        meta: {
          title: '编辑客诉',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/warning-system/custom-warning/custom-warning-detail.vue'),
      },
    ],
  },

  // 服务质检
  // {
  //   name: 'SERVICE-QUALITY-INDEX',
  //   path: '/service-quality/index',
  //   redirect: '/service-quality/compare',
  //   meta: {
  //     title: '服务质检',
  //   },
  //   component: () => import('@/hotelcem/views/service-quality/index'),
  // children: [
  // 服务概览
  {
    path: '/service-quality/service-overview',
    name: 'SERVICE-OVERVIEW',
    meta: {
      title: '服务概览',
    },
    component: () => import('@/hotelcem/views/service-quality/overview'),
  },
  {
    path: '/service-quality/comment-quality',
    name: 'COMMENT-QUALITY',
    meta: {
      title: '点评质检',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/service-quality/comment-quality/index'),
  },
  // 商圈/竞对质检
  {
    path: '/service-quality/compare',
    name: 'SERVICE-QUALITY-COMPARE',
    meta: {
      title: '竞对质检',
    },
    component: () => import('@/hotelcem/views/service-quality/compare'),
  },
  {
    path: '/service-quality/department-quality',
    name: 'DEPARTMENT-QUALITY',
    meta: {
      title: '部门质检',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/service-quality/department-quality/index'),
  },
  {
    path: '/service-quality/weekly-report',
    name: 'WEEKLY-REPORT',
    meta: {
      title: '运营报表',
    },
    // component: () => import('@/hotelcem/views/service-quality/weekly-report/weeklyReport'),
    component: () => import('@/hotelcem/views/service-quality/weekly-report/index'),
  },
  {
    path: '/service-quality/daily-report',
    name: 'DAILY-REPORT',
    meta: {
      title: '运营日报',
    },
    component: () => import('@/hotelcem/views/service-quality/daily-report/index'),
  },
  {
    path: '/service-quality/customer-journey',
    name: 'CUSTOMER-JOURNEY',
    meta: {
      title: '客户旅程',
    },
    component: () => import('@/hotelcem/views/service-quality/customer-journey/index'),
  },
  // ],
  // },

  // 数据中心
  {
    name: 'DATA-CENTER-INDEX',
    path: '/data-center',
    redirect: '/data-center/survey-data',
    meta: {
      title: '数据中心',
      hideInH5: true,
    },
    component: () => import('@/xreports/views/data-center/index'),
    children: [
      {
        // 问卷数据
        name: 'DATA-CENTER-SURVEY-DATA',
        path: 'survey-data',
        meta: {
          title: '问卷数据',
          hideTitle: true,
        },
        component: () => import('@/xreports/views/data-center/survey-data/index'),
      },
      {
        // 文件数据
        name: 'DATA-CENTER-FILE-DATA',
        path: 'file-data',
        meta: {
          title: '文件数据',
          hideTitle: true,
        },
        component: () => import('@/xreports/views/data-center/file-data/index'),
      },
      {
        // 合表数据
        name: 'DATA-CENTER-MERGED-CELL-DATA',
        path: 'merged-cell-data',
        meta: {
          title: '合表数据',
          hideTitle: true,
        },
        component: () => import('@/xreports/views/data-center/merged-data/index'),
      },
      {
        // 爬虫数据
        name: 'DATA-CENTER-SOCIAL-DATA',
        path: 'social-data',
        meta: {
          title: '社交媒体数据',
          hideTitle: true,
        },
        component: () => import('@/xreports/views/data-center/social-data/index'),
      },
      {
        // 语音数据
        name: 'DATA-CENTER-VOICE-DATA',
        path: 'voice-data',
        meta: {
          title: '语音数据',
          hideTitle: true,
        },
        component: () => import('@/hotelcem/views/data-center/voice-data/index'),
      },
      {
        // IM数据
        name: 'DATA-CENTER-IM-DATA',
        path: 'im-data',
        meta: {
          title: 'IM数据',
          hideTitle: true,
        },
        component: () => import('@/xreports/views/data-center/im-data/index'),
      },
      {
        // 对接数据
        name: 'DATA-CENTER-INTEGRATED-DATA',
        path: 'integrated-data',
        meta: {
          title: '对接数据',
          hideTitle: true,
        },
        component: () => import('@/xreports/views/data-center/integrated-data/index'),
      },
      {
        // 数据详情
        name: 'DATA-CENTER-TABLE-DATA-DETAIL',
        path: 'table-data/:id',
        meta: {
          title: '数据详情',
          hideTitle: true,
        },
        component: () => import('@/hotelcem/views/data-center/detail'),
      },
      // 报表中心
      {
        name: 'DATA-CENTER-REPORT-CENTER',
        path: 'report-center',
        meta: {
          title: '报表中心',
          hideTitle: true,
        },
        component: () => import('@/hotelcem/views/data-center/report-center/index'),
      },

      // 登录统计
      {
        name: 'HOTEL-LOGIN-RANK-LOG',
        path: 'login-rank',
        component: () => import('@/xreports/views/hotel-action-manage/LoginRank.vue'),
        meta: {
          title: '账号登录排名',
          hideTitle: true,
        },
      },
    ],
  },

  // 舆情管理
  // {
  //   name: 'COMMENT-ANALYSIS',
  //   path: '/comment-analysis',
  //   redirect: '/comment-analysis/index',
  //   meta: {
  //     title: '舆情管理',
  //   },
  //   component: () => import('@/hotelcem/views/comment-analysis/layout'),
  // children: [
  // 舆情管理
  {
    path: '/comment-analysis/index-new',
    name: 'COMMENT-ANALYSIS-INDEX-NEW',
    meta: {
      title: '点评渠道分析',
    },
    component: () => import('@/hotelcem/views/comment-analysis/index-new'),
  },

  {
    path: '/comment-analysis/index',
    name: 'COMMENT-ANALYSIS-INDEX',
    meta: {
      title: '点评整体分析',
    },
    component: () => import('@/hotelcem/views/comment-analysis/index'),
  },

  {
    path: '/comment-analysis-group/index',
    name: 'COMMENT-ANALYSIS-INDEX-GROUP',
    meta: {
      title: '集团点评整体分析',
    },
    component: () => import('@/hotelcem/views/comment-analysis-group/index'),
  },

  // 酒店CEM点评管理
  {
    path: '/comment-analysis/comment-list',
    name: 'COMMENT-ANALYSIS-LIST',
    meta: {
      title: '点评管理',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/comment-analysis/CommentList'),
  },
  //点评管理 cem的多店版
  {
    path: '/comment-analysis/comment-list-group',
    name: 'COMMENT-ANALYSIS-LIST-GROUP',
    meta: {
      title: '集团点评管理',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/comment-analysis/CommentList-group'),
  },

  // 酒店CEM竞争力分析
  {
    path: '/comment-analysis/compete',
    name: 'COMMENT-ANALYSIS-COMPETE',
    meta: {
      title: '竞争分析',
    },
    component: () => import('@/hotelcem/views/comment-analysis/compete'),
  },
  // 酒店CEM多店竞争力分析
  {
    path: '/comment-analysis/compete-group',
    name: 'COMMENT-ANALYSIS-COMPETE-GROUP',
    meta: {
      title: '集团竞争分析',
    },
    component: () => import('@/hotelcem/views/compete-analysis-group/compete'),
  },
  // 华客分管理
  {
    path: '/comment-analysis/vocust-score',
    name: 'COMMENT-ANALYSIS-VOCUST-SCORE',
    meta: {
      title: '华客分',
    },
    component: () => import('@/hotelcem/views/comment-analysis/vocustScore.vue'),
  },
  // CSI行业洞察
  {
    path: '/comment-analysis/industry-insight',
    name: 'COMMENT-ANALYSIS-INDUSTRY-INSIGHT',
    meta: {
      title: 'CSI行业洞察',
    },
    component: () => import('@/hotelcem/views/comment-analysis/industryInsight.vue'),
  },
  // 平台NPS分析
  {
    path: '/comment-analysis/nps-analysis',
    name: 'COMMENT-NPS-ANALYSIS',
    meta: {
      title: '携程NPS管理',
    },
    component: () => import('@/hotelcem/views/comment-analysis/nps-analysis.vue'),
  },
  {
    path: '/comment-analysis/intelligence-reports',
    name: 'COMMENT-INTELLIGENCE-REPORTS',
    meta: {
      title: '智能报告',
    },
    component: () => import('@/hotelcem/views/intelligence-reports/index.vue'),
  },

  // ],
  // },

  // 市场分析
  {
    name: 'MARKET-ANALYSIS',
    path: '/marketAnalysis',
    redirect: '/marketAnalysis/business-circle-heat',
    component: () => import('@/hotelcem/views/marketAnalysis/index'),
    meta: {
      title: '市场分析',
    },
    children: [
      {
        name: 'BUSINESS-CIRCLE-HEAT',
        path: '/marketAnalysis/business-circle-heat',
        component: () => import('@/hotelcem/views/marketAnalysis/BusinessCircleHeat.vue'),
        meta: {
          title: '商圈热度',
        },
      },
      {
        path: '/marketAnalysis/priceAnalysis',
        name: 'REPORTS-MARKET-ANALYSIS',
        meta: {
          title: '调价看板',
        },
        component: () => import('@/hotelcem/views/marketAnalysis/priceAnalysis.vue'),
      },
      {
        // 热门话题
        name: 'DATA-CENTER-HOT-TOPIC',
        path: '/marketAnalysis/hot-topic',
        meta: {
          title: '热门话题',
          hideTitle: true,
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/marketAnalysis/hot-topic/index'),
      },
      {
        // 热门话题详情
        name: 'DATA-CENTER-HOT-TOPIC-DETAIL',
        path: '/marketAnalysis/hot-topic-detail/:articleId',
        meta: {
          title: '热门话题详情',
          hideTitle: true,
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/marketAnalysis/hot-topic/detail'),
      },
    ],
  },

  // 客户管理
  // {
  //   name: 'CUSTOMER-MANAGE',
  //   path: '/customer-manage',
  //   redirect: '/customer-manage/customer-center',
  //   meta: {
  //     title: '客户管理',
  //   },
  //   component: () => import('@/xreports/views/customer-manage/index.vue'),
  //   children: [
  {
    name: 'CUSTOMER-CENTER',
    path: '/customer-manage/customer-center',
    meta: {
      title: '宾客偏好',
    },
    component: () => import('@/xreports/views/customer-manage/customer-center.vue'),
  },
  // ],
  // },

  // 配置中心
  // {
  //   name: 'CONFIGURATION-CENTER-INDEX',
  //   path: '/configuration-center',
  //   redirect: '/configuration-center/warning-rules',
  //   meta: {
  //     title: '配置中心',
  //   },
  //   component: () => import('@/hotelcem/views/action-record/index'),
  //   children: [
  // 竞对管理
  {
    name: 'CONFIGURATION-CENTER-COMPETITION-MANAGEMENT',
    path: '/configuration-center/competition-management',
    component: () => import('@/hotelcem/views/configuration-center/competition-management/index'),
    meta: {
      title: '竞对管理',
      hideInH5: true,
    },
  },
  // 预警规则
  {
    name: 'ACTION-RECORD-WARNING-RULES',
    path: '/configuration-center/warning-rules',
    meta: {
      title: '预警规则',
      hideInH5: true,
    },
    component: () => import('@/hotelcem/views/action-record/warning-rules/index'),
  },
  // 预警详情和新建预警
  {
    name: 'ACTION-RECORD-WARNING-RULES-DETAIL',
    path: '/configuration-center/rules-detail',
    meta: {
      title: '规则详情',
      hideInH5: true,
    },
    component: () => import('@/hotelcem/views/action-record/rules-detail/index'),
  },
  // 机器人通知
  {
    name: 'CONFIGURATION-CENTER-ROBOT-NOTIFICATION',
    path: '/configuration-center/robot-notification',
    component: () => import('@/modules/robot-notification/index'),
    meta: {
      title: '机器人通知',
      hideTitle: true,
      hideInH5: true,
    },
  },
  {
    // 通知中心
    name: 'CONFIGURATION-NOTIFICATION-TASK-LIST-INDEX',
    path: '/configuration-center/notify/task-list',
    meta: {
      title: '通知中心',
      hideInH5: true,
    },
    component: () => import('@/hotelcem/views/configuration-center/notification-center/task-list/index'),
  },
  // 通知中心-添加任务
  {
    name: 'CONFIGURATION-NOTIFICATION-ADD-TASK-INDEX',
    path: '/configuration-center/add-task',
    meta: {
      title: '添加通知',
      hideInH5: true,
    },
    component: () => import('@/hotelcem/views/configuration-center/notification-center/add-task/index'),
  },
  // 成员管理
  {
    name: 'CONFIGURATION-CENTER-MEMBERS-MANAGEMENT',
    path: '/configuration-center/members-management',
    meta: {
      title: '成员管理',
    },
    component: () => import('@/hotelcem/views/configuration-center/members-entry'),
  },
  // 组织成员管理
  {
    name: 'CONFIGURATION-CENTER-ORG-MEMBERS-MANAGEMENT',
    path: '/configuration-center/org-members-management',
    meta: {
      title: '组织成员管理',
    },
    component: () => import('@/hotelcem/views/configuration-center/org-members-management/index'),
  },
  // 通讯录管理
  {
    name: 'CONFIGURATION-CENTER-TELEPHONE-MANAGEMENT',
    path: '/configuration-center/telephone-management',
    component: () => import('@/hotelcem/views/configuration-center/telephone-extension-management/index'),
    meta: {
      title: '通讯录管理',
      hideInH5: true,
    },
  },
  {
    name: 'CONFIGURATION-CENTER-WHITW-LIST',
    path: '/configuration-center/white-list',
    component: () => import('@/hotelcem/views/configuration-center/telephone-extension-management/white-list'),
    meta: {
      title: '设置',
      hideInH5: true,
    },
  },
  {
    name: 'CONFIGURATION-CENTER-COMPLAINTS-LEVEL',
    path: '/configuration-center/complaints-level',
    component: () => import('@/hotelcem/views/configuration-center/customer-complaints-levels/index'),
    meta: {
      title: '自定义客诉级别',
      hideInH5: true,
    },
  },

  // 考核指标
  {
    name: 'CONFIGURATION-CENTER-ASSESSMENT-INDICATORS',
    path: '/configuration-center/assessment-indicators',
    component: () => import('@/hotelcem/views/configuration-center/assessment-indicators/index'),
    meta: {
      title: 'KPI管理',
    },
  },

  // 考核指标多店版本
  {
    name: 'CONFIGURATION-CENTER-ASSESSMENT-INDICATORS-GROUP',
    path: '/configuration-center/assessment-indicators-group',
    component: () => import('@/hotelcem/views/configuration-center/assessment-indicators-group/index'),
    meta: {
      title: '集团KPI管理',
    },
  },

  // 内部报障
  {
    name: 'INSIDE-COMPLAINT',
    path: '/configuration-center/inside-complaint',
    component: () => import('@/hotelcem/views/inside-complaint/index.vue'),
    meta: {
      title: '内部报障',
    },
  },

  // 学习园地列表
  {
    name: 'CONFIGURATION-CENTER-LEARNING-CENTER-LIST',
    path: '/configuration-center/learning-center/index',
    component: () => import('@/hotelcem/views/configuration-center/learning-center/index'),
    meta: {
      title: '学习园地',
    },
  },

  // 学习园地详情
  {
    name: 'CONFIGURATION-CENTER-LEARNING-CENTER-DETAIL',
    path: '/configuration-center/learning-center/detail',
    component: () => import('@/hotelcem/views/configuration-center/learning-center/detail'),
    meta: {
      title: '学习园地详情',
    },
  },

  // 自主纠错控制中心
  {
    name: 'CONFIGURATION-CENTER-SELF_CORRECT',
    path: '/configuration-center/self-correcting',
    component: () => import('@/hotelcem/views/configuration-center/self-correcting/index'),
    meta: {
      title: '住中自主纠错',
    },
  },
  // ],
  // },
]

export const newAsyncRoutes = [
  {
    name: 'HOTEL-CEM-HOME',
    path: '/home',
    meta: {
      title: '首页(新)',
    },
    component: () => import('@hotelcem/views/home-new/index.vue'),
  },
  // 老首页
  {
    name: 'HOTEL-CEM-HOME-CEM',
    path: '/home-cem',
    meta: {
      title: '首页',
    },
    component: () =>
      import(/* webpackPreload: true, webpackMode: 'eager', webpackChunkName: 'home' */ '@hotelcem/views/home/Home'),
  },
  // 住中语音
  {
    name: 'VOC_1',
    path: '/warning-system',
    redirect: '/warning-system/warning-analysis',
    meta: {
      title: '住中语音',
    },
    component: () => import('@hotelcem/views/warning-system/index'),
    children: [
      {
        name: 'Analysis_2',
        path: '/warning-system',
        redirect: '/warning-system/warning-analysis',
        meta: {
          title: '住中分析',
        },
        component: () => import('@hotelcem/views/warning-system/index'),
        props: { device: storeCEM.getters.deviceMode },
        children: [
          // 语音分析
          {
            name: 'VOICE-ANALYSIS-INDEX',
            path: '/voice-analysis/index',
            meta: {
              title: '语音分析',
              voiceType: 'OVERVIEW',
            },
            component: () => import('@/hotelcem/views/voice-analysis/call-overview/index.vue'),
            props: { device: storeCEM.getters.deviceMode },
          },
          // 客诉分析
          {
            name: 'WARNING-SYSTEM-WARNING-ANALYSIS',
            path: '/warning-system/warning-analysis',
            meta: {
              title: '客诉分析',
              voiceType: 'COMPLAINT',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@/hotelcem/views/voice-analysis/call-overview/index'),
          },
        ],
      },
      {
        name: 'Records_2',
        path: '/warning-system',
        redirect: '/warning-system/warning-analysis',
        meta: {
          title: '住中数据记录',
        },
        component: () => import('@hotelcem/views/warning-system/index'),
        children: [
          // 语音记录
          {
            name: 'VOICE-ANALYSIS-DEMAND-DETAIL',
            path: '/voice-analysis/demand-detail',
            meta: {
              title: '语音记录',
              voiceType: 'ALL',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@hotelcem/views/warning-system/warning-record/index'),
          },
          // 客诉记录
          {
            name: 'WARNING-SYSTEM-WARNING-RECORD',
            path: '/warning-system/warning-record',
            meta: {
              title: '客诉记录',
              voiceType: 'COMPLAINT',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@hotelcem/views/warning-system/warning-record/index'),
          },
          // 线下客诉列表
          {
            name: 'CUSTOM-WARNING-LIST',
            path: '/custom-warning/list',
            meta: {
              title: '线下客诉',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@/hotelcem/views/warning-system/custom-warning/index.vue'),
          },
        ],
      },
      // 暂未分配二级菜单
      // 平台投诉
      {
        name: 'WARNING-SYSTEM-COMPLAINT-RECORD',
        path: '/warning-system/complaint-record',
        meta: {
          title: '平台投诉',
          voiceType: 'COMPLAINT',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@hotelcem/views/warning-system/complaint-record/index'),
      },
      // 语音记录详情
      {
        name: 'WARNING-SYSTEM-WARNING-RECORD-DETAIL-NORMAL',
        path: '/voice-system/record-detail',
        meta: {
          title: '详情',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/warning-system/warning-record/record-detail'),
      },
      // 客诉记录详情
      {
        name: 'WARNING-SYSTEM-WARNING-RECORD-DETAIL',
        path: '/warning-system/record-detail',
        meta: {
          title: '详情',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/warning-system/warning-record/record-detail'),
      },
      // 线下客诉详情
      {
        name: 'CUSTOM-WARNING-DETAIL',
        path: '/custom-warning/detail',
        meta: {
          title: '编辑客诉',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/warning-system/custom-warning/custom-warning-detail.vue'),
      },
    ],
  },
  // 集团数据分析
  {
    name: 'Group_1',
    path: '',
    meta: {
      title: '集团数据分析',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        name: 'Group_Reviews_2',
        path: '/comment-analysis',
        meta: {
          title: '集团舆情管理',
        },
        component: { render: e => e('router-view') },
        children: [
          {
            path: '/comment-analysis/comment-list-group',
            name: 'COMMENT-ANALYSIS-LIST-GROUP',
            meta: {
              title: '集团点评管理',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@/hotelcem/views/comment-analysis/CommentList-group'),
          },
          {
            path: '/comment-analysis/compete-group',
            name: 'COMMENT-ANALYSIS-COMPETE-GROUP',
            meta: {
              title: '集团竞争分析',
            },
            component: () => import('@/hotelcem/views/compete-analysis-group/compete'),
          },
          {
            path: '/comment-analysis-group/index',
            name: 'COMMENT-ANALYSIS-INDEX-GROUP',
            meta: {
              title: '集团点评整体分析',
            },
            component: () => import('@/hotelcem/views/comment-analysis-group/index'),
          },
          {
            path: '/marketAnalysis/hot-topic-group',
            name: 'HOTEL-TOPIC-GROUP',
            meta: {
              title: '集团版热门话题',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@/hotelcem/views/marketAnalysis/hot-topic-group/index'),
          },
        ],
      },
      {
        name: 'Group_VOC_2',
        path: '/',
        meta: {
          title: '集团住中语音',
        },
        component: { render: e => e('router-view') },
        children: [
          {
            path: '/voice-analysis/index-group',
            name: 'VOICE-ANALYSIS-INDEX-GROUP',
            meta: {
              title: '集团语音分析new',
              voiceType: 'OVERVIEW',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@/hotelcem/views/voice-analysis/call-overview/index-group.vue'),
          },
          {
            path: '/service-quality/comment-quality',
            name: 'COMMENT-QUALITY',
            meta: {
              title: '点评质检',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@/hotelcem/views/service-quality/comment-quality/index'),
          },
          {
            name: 'WARNING-SYSTEM-WARNING-ANALYSIS-GROUP',
            path: '/warning-system/warning-analysis-group',
            meta: {
              title: '集团客诉分析',
              voiceType: 'COMPLAINT',
            },
            props: { device: storeCEM.getters.deviceMode },
            component: () => import('@/hotelcem/views/voice-analysis/call-overview/index-group'),
          },
        ],
      },
    ],
  },
  // 问题定位
  {
    name: 'Key_Issues_1',
    path: '/',
    meta: {
      title: '问题定位',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        path: '/service-quality/service-overview',
        name: 'SERVICE-OVERVIEW',
        meta: {
          title: '服务概览',
        },
        component: () => import('@/hotelcem/views/service-quality/overview'),
      },
      {
        path: '/service-quality/department-quality',
        name: 'DEPARTMENT-QUALITY',
        meta: {
          title: '部门质检',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/service-quality/department-quality/index'),
      },
      {
        path: '/service-quality/customer-journey',
        name: 'CUSTOMER-JOURNEY',
        meta: {
          title: '客户旅程',
        },
        component: () => import('@/hotelcem/views/service-quality/customer-journey/index'),
      },
    ],
  },
  // 报表与汇报
  {
    name: 'Reports_1',
    path: '/data-center',
    meta: {
      title: '报表与汇报',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        path: '/service-quality/weekly-report',
        name: 'WEEKLY-REPORT',
        meta: {
          title: '运营报表',
        },
        component: () => import('@/hotelcem/views/service-quality/weekly-report/index'),
      },
      {
        path: '/service-quality/daily-report',
        name: 'DAILY-REPORT',
        meta: {
          title: '运营日报',
        },
        component: () => import('@/hotelcem/views/service-quality/daily-report/index'),
      },
      {
        path: '/comment-analysis/intelligence-reports',
        name: 'COMMENT-INTELLIGENCE-REPORTS',
        meta: {
          title: '智能报告',
        },
        component: () => import('@/hotelcem/views/intelligence-reports/index.vue'),
      },
      // 报表中心
      {
        name: 'DATA-CENTER-REPORT-CENTER',
        path: 'report-center',
        meta: {
          title: '报表中心',
          hideTitle: true,
        },
        component: () => import('@/hotelcem/views/data-center/report-center/index'),
      },
      {
        path: '/service-quality/compare',
        name: 'SERVICE-QUALITY-COMPARE',
        meta: {
          title: '竞对质检',
        },
        component: () => import('@/hotelcem/views/service-quality/compare'),
      },
    ],
  },
  // 其它
  {
    name: 'More_1',
    path: '/data-center',
    meta: {
      title: '其他',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        name: 'Data_Center_2',
        path: '/data-center',
        redirect: '/data-center/survey-data',
        meta: {
          title: '数据中心',
          hideInH5: true,
        },
        component: () => import('@/xreports/views/data-center/index'),
        children: [
          {
            // 问卷数据
            name: 'DATA-CENTER-SURVEY-DATA',
            path: 'survey-data',
            meta: {
              title: '问卷数据',
              hideTitle: true,
            },
            component: () => import('@/xreports/views/data-center/survey-data/index'),
          },
          {
            // 文件数据
            name: 'DATA-CENTER-FILE-DATA',
            path: 'file-data',
            meta: {
              title: '文件数据',
              hideTitle: true,
            },
            component: () => import('@/xreports/views/data-center/file-data/index'),
          },
          {
            // 合表数据
            name: 'DATA-CENTER-MERGED-CELL-DATA',
            path: 'merged-cell-data',
            meta: {
              title: '合表数据',
              hideTitle: true,
            },
            component: () => import('@/xreports/views/data-center/merged-data/index'),
          },
          {
            name: 'DATA-CENTER-SOCIAL-DATA',
            path: 'social-data',
            meta: {
              title: '社交媒体数据',
              hideTitle: true,
            },
            component: () => import('@/xreports/views/data-center/social-data/index'),
          },
          {
            // 语音数据
            name: 'DATA-CENTER-VOICE-DATA',
            path: 'voice-data',
            meta: {
              title: '语音数据',
              hideTitle: true,
            },
            component: () => import('@/hotelcem/views/data-center/voice-data/index'),
          },
          {
            // IM数据
            name: 'DATA-CENTER-IM-DATA',
            path: 'im-data',
            meta: {
              title: 'IM数据',
              hideTitle: true,
            },
            component: () => import('@/xreports/views/data-center/im-data/index'),
          },
          {
            // 对接数据
            name: 'DATA-CENTER-INTEGRATED-DATA',
            path: 'integrated-data',
            meta: {
              title: '对接数据',
              hideTitle: true,
            },
            component: () => import('@/xreports/views/data-center/integrated-data/index'),
          },
          // 登录统计
          {
            name: 'HOTEL-LOGIN-RANK-LOG',
            path: 'login-rank',
            component: () => import('@/xreports/views/hotel-action-manage/LoginRank.vue'),
            meta: {
              title: '账号登录排名',
              hideTitle: true,
            },
          },
        ],
      },
      {
        // 数据详情
        name: 'DATA-CENTER-TABLE-DATA-DETAIL',
        path: 'table-data/:id',
        meta: {
          title: '数据详情',
          hideTitle: true,
        },
        component: () => import('@/hotelcem/views/data-center/detail'),
      },
    ],
  },
  // 舆情管理
  {
    name: 'Reviews_1',
    path: '/',
    meta: {
      title: '舆情管理',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        path: '/comment-analysis/comment-list',
        name: 'COMMENT-ANALYSIS-LIST',
        meta: {
          title: '点评管理',
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/comment-analysis/CommentList'),
      },
      {
        name: 'Review_Analysis_2',
        path: '/',
        meta: {
          title: '点评分析',
        },
        component: { render: e => e('router-view') },
        children: [
          {
            path: '/comment-analysis/index-new',
            name: 'COMMENT-ANALYSIS-INDEX-NEW',
            meta: {
              title: '点评渠道分析',
            },
            component: () => import('@/hotelcem/views/comment-analysis/index-new'),
          },
          {
            path: '/comment-analysis/index',
            name: 'COMMENT-ANALYSIS-INDEX',
            meta: {
              title: '点评整体分析',
            },
            component: () => import('@/hotelcem/views/comment-analysis/index'),
          },
        ],
      },
      {
        path: '/comment-analysis/vocust-score',
        name: 'COMMENT-ANALYSIS-VOCUST-SCORE',
        meta: {
          title: '华客分',
        },
        component: () => import('@/hotelcem/views/comment-analysis/vocustScore.vue'),
      },
      // 平台NPS分析
      {
        path: '/comment-analysis/nps-analysis',
        name: 'COMMENT-NPS-ANALYSIS',
        meta: {
          title: '携程NPS管理',
        },
        component: () => import('@/hotelcem/views/comment-analysis/nps-analysis.vue'),
      },
      {
        // 热门话题
        name: 'DATA-CENTER-HOT-TOPIC',
        path: '/marketAnalysis/hot-topic',
        meta: {
          title: '新媒体监控',
          hideTitle: true,
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/marketAnalysis/hot-topic/index'),
      },
      {
        // 热门话题详情
        name: 'DATA-CENTER-HOT-TOPIC-DETAIL',
        path: '/marketAnalysis/hot-topic-detail/:articleId',
        meta: {
          title: '热门话题详情',
          hideTitle: true,
        },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/marketAnalysis/hot-topic/detail'),
      },
      {
        name: 'BUSINESS-CIRCLE-HEAT',
        path: '/marketAnalysis/business-circle-heat',
        component: () => import('@/hotelcem/views/marketAnalysis/BusinessCircleHeat.vue'),
        meta: {
          title: '商圈热度',
        },
      },
      {
        path: '/marketAnalysis/priceAnalysis',
        name: 'REPORTS-MARKET-ANALYSIS',
        meta: {
          title: '调价看板',
        },
        component: () => import('@/hotelcem/views/marketAnalysis/priceAnalysis.vue'),
      },
    ],
  },
  // 行业与竞争
  {
    name: 'Industry_Competition_1',
    path: '/',
    meta: {
      title: '行业与竞争',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        path: '/comment-analysis/compete',
        name: 'COMMENT-ANALYSIS-COMPETE',
        meta: {
          title: 'OTA竞争分析',
        },
        component: () => import('@/hotelcem/views/comment-analysis/compete'),
      },
      {
        path: '/comment-analysis/industry-insight',
        name: 'COMMENT-ANALYSIS-INDUSTRY-INSIGHT',
        meta: {
          title: 'CSI行业洞察',
        },
        component: () => import('@/hotelcem/views/comment-analysis/industryInsight.vue'),
      },
    ],
  },
  // CDP
  {
    name: 'Customers_1',
    path: '/',
    meta: {
      title: 'CDP',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        name: 'CUSTOMER-CENTER',
        path: '/customer-manage/customer-center',
        meta: {
          title: '宾客偏好',
        },
        component: () => import('@/xreports/views/customer-manage/customer-center.vue'),
      },
    ],
  },
  // 配置中心
  {
    name: 'Settings_1',
    path: '/',
    meta: {
      title: '配置中心',
    },
    component: { render: e => e('router-view') },
    children: [
      {
        name: 'CONFIGURATION-CENTER-COMPETITION-MANAGEMENT',
        path: '/configuration-center/competition-management',
        component: () => import('@/hotelcem/views/configuration-center/competition-management/index'),
        meta: {
          title: '竞对管理',
          hideInH5: true,
        },
      },
      // 预警规则
      {
        name: 'ACTION-RECORD-WARNING-RULES',
        path: '/configuration-center/warning-rules',
        meta: {
          title: '预警规则',
          hideInH5: true,
        },
        component: () => import('@/hotelcem/views/action-record/warning-rules/index'),
      },
      // 预警详情和新建预警
      {
        name: 'ACTION-RECORD-WARNING-RULES-DETAIL',
        path: '/configuration-center/rules-detail',
        meta: {
          title: '规则详情',
          hideInH5: true,
        },
        component: () => import('@/hotelcem/views/action-record/rules-detail/index'),
      },
      // 机器人通知
      {
        name: 'CONFIGURATION-CENTER-ROBOT-NOTIFICATION',
        path: '/configuration-center/robot-notification',
        component: () => import('@/modules/robot-notification/index'),
        meta: {
          title: '机器人通知',
          hideTitle: true,
          hideInH5: true,
        },
      },
      {
        // 通知中心
        name: 'CONFIGURATION-NOTIFICATION-TASK-LIST-INDEX',
        path: '/configuration-center/notify/task-list',
        meta: {
          title: '通知中心',
          hideInH5: true,
        },
        component: () => import('@/hotelcem/views/configuration-center/notification-center/task-list/index'),
      },
      // 通知中心-添加任务
      {
        name: 'CONFIGURATION-NOTIFICATION-ADD-TASK-INDEX',
        path: '/configuration-center/add-task',
        meta: {
          title: '添加通知',
          hideInH5: true,
        },
        component: () => import('@/hotelcem/views/configuration-center/notification-center/add-task/index'),
      },
      // 成员管理
      {
        name: 'CONFIGURATION-CENTER-MEMBERS-MANAGEMENT',
        path: '/configuration-center/members-management',
        meta: {
          title: '成员管理',
        },
        component: () => import('@/hotelcem/views/configuration-center/members-entry'),
      },
      // 组织成员管理
      {
        name: 'CONFIGURATION-CENTER-ORG-MEMBERS-MANAGEMENT',
        path: '/configuration-center/org-members-management',
        meta: {
          title: '组织成员管理',
        },
        component: () => import('@/hotelcem/views/configuration-center/org-members-management/index'),
      },
      // 通讯录管理
      {
        name: 'CONFIGURATION-CENTER-TELEPHONE-MANAGEMENT',
        path: '/configuration-center/telephone-management',
        component: () => import('@/hotelcem/views/configuration-center/telephone-extension-management/index'),
        meta: {
          title: '通讯录管理',
          hideInH5: true,
        },
      },
      {
        name: 'CONFIGURATION-CENTER-WHITW-LIST',
        path: '/configuration-center/white-list',
        component: () => import('@/hotelcem/views/configuration-center/telephone-extension-management/white-list'),
        meta: {
          title: '设置',
          hideInH5: true,
        },
      },
      // 自主纠错控制中心
      {
        name: 'CONFIGURATION-CENTER-SELF_CORRECT',
        path: '/configuration-center/self-correcting',
        component: () => import('@/hotelcem/views/configuration-center/self-correcting/index'),
        meta: {
          title: '住中自主纠错',
        },
      },
      {
        name: 'CONFIGURATION-CENTER-COMPLAINTS-LEVEL',
        path: '/configuration-center/complaints-level',
        component: () => import('@/hotelcem/views/configuration-center/customer-complaints-levels/index'),
        meta: {
          title: '自定义客诉级别',
          hideInH5: true,
        },
      },

      // 考核指标
      {
        name: 'CONFIGURATION-CENTER-ASSESSMENT-INDICATORS',
        path: '/configuration-center/assessment-indicators',
        component: () => import('@/hotelcem/views/configuration-center/assessment-indicators/index'),
        meta: {
          title: 'KPI管理',
        },
      },

      // 考核指标多店版本
      {
        name: 'CONFIGURATION-CENTER-ASSESSMENT-INDICATORS-GROUP',
        path: '/configuration-center/assessment-indicators-group',
        component: () => import('@/hotelcem/views/configuration-center/assessment-indicators-group/index'),
        meta: {
          title: '集团KPI管理',
        },
      },

      // 内部报障
      {
        name: 'INSIDE-COMPLAINT',
        path: '/configuration-center/inside-complaint',
        component: () => import('@/hotelcem/views/inside-complaint/index.vue'),
        meta: {
          title: '内部报障',
        },
      },
    ],
  },
  // 学习园地
  // 学习园地列表
  {
    name: 'CONFIGURATION-CENTER-LEARNING-CENTER-LIST',
    path: '/configuration-center/learning-center/index',
    component: () => import('@/hotelcem/views/configuration-center/learning-center/index'),
    meta: {
      title: '学习园地',
    },
  },

  // 学习园地详情
  {
    name: 'CONFIGURATION-CENTER-LEARNING-CENTER-DETAIL',
    path: '/configuration-center/learning-center/detail',
    component: () => import('@/hotelcem/views/configuration-center/learning-center/detail'),
    meta: {
      title: '学习园地详情',
    },
  },
]

export default [
  // userInfo
  {
    name: 'USER-INFO',
    path: '/user/info',
    component: () => import('@/modules/user/info'),
  },

  //  企业设置
  {
    name: 'ENTERPRISE-CONFIGURATION-INDEX',
    path: '/enterprise-configuration',
    redirect: '/enterprise-configuration/management',
    meta: {
      title: '企业设置',
    },
    component: () => import('@/modules/enterprise-configuration/index'),
    children: [
      {
        name: 'ENTERPRISE-CONFIGURATION-MANAGEMENT',
        path: 'management',
        meta: {
          aside: true,
          asideKey: 'enterpriseConfiguration',
          title: '企业设置 - 配置管理',
          layoutClass: 'page-enterprise-configuration-management-basic-wrapper',
        },
        component: () => import('@/modules/enterprise-configuration/management'),
      },
    ],
  },

  // 自主纠错控制中心
  {
    name: 'CONFIGURATION-CENTER-SELF_CORRECT',
    path: '/configuration-center/self-correcting',
    component: () => import('@/hotelcem/views/configuration-center/self-correcting/index'),
    meta: {
      title: '住中自主纠错',
    },
  },

  {
    // 热门话题详情
    name: 'DATA-CENTER-HOT-TOPIC-DETAIL',
    path: '/marketAnalysis/hot-topic-detail/:articleId',
    meta: {
      title: '热门话题详情',
      hideTitle: true,
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/marketAnalysis/hot-topic/detail'),
  },
  // {
  //   path: '/service-quality/comment-quality',
  //   name: 'COMMENT-QUALITY',
  //   meta: {
  //     title: '点评质检',
  //   },
  //   props: { device: storeCEM.getters.deviceMode },
  //   component: () => import('@/hotelcem/views/service-quality/comment-quality/index'),
  // },
  {
    path: '/marketAnalysis/hot-topic-group-detail/:articleId',
    name: 'HOTEL-TOPIC-GROUP-DETAIL',
    meta: {
      title: '集团版热门话题详情',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/marketAnalysis/hot-topic-group/detail'),
  },
  {
    path: '/marketAnalysis/hot-topic-group',
    name: 'HOTEL-TOPIC-GROUP',
    meta: {
      title: '集团版热门话题',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/marketAnalysis/hot-topic-group/index'),
  },
  {
    path: '/voice-analysis/index-group',
    name: 'VOICE-ANALYSIS-INDEX-GROUP',
    meta: {
      title: '集团语音分析new',
      voiceType: 'OVERVIEW',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/voice-analysis/call-overview/index-group.vue'),
  },
  {
    name: 'WARNING-SYSTEM-WARNING-ANALYSIS-GROUP',
    path: '/warning-system/warning-analysis-group',
    meta: {
      title: '集团客诉分析',
      voiceType: 'COMPLAINT',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/voice-analysis/call-overview/index-group'),
  },
  // 考核指标多店版本
  {
    name: 'CONFIGURATION-CENTER-ASSESSMENT-INDICATORS-GROUP',
    path: '/configuration-center/assessment-indicators-group',
    component: () => import('@/hotelcem/views/configuration-center/assessment-indicators-group/index'),
    meta: {
      title: '集团KPI管理',
    },
  },

  {
    name: 'CUSTOMIZED-DASHBOARD-INDEX',
    path: '/board/:id',
    meta: {
      title: '华客看板',
    },
    component: () => import('@/xreports/views/customized-dashboard/index'),
  },
  {
    name: 'NOTICE',
    path: '/notice',
    meta: {
      title: '站内信',
    },
    component: () => import('@/hotelcem/views/notice/index.vue'),
    redirect: '/notice/notice-list',
    children: [
      {
        name: 'NOTICE-RECEIVELIST',
        path: '/notice/notice-list',
        meta: { title: '收件箱' },
        props: { device: storeCEM.getters.deviceMode },
        component: () => import('@/hotelcem/views/notice/noticeList.vue'),
      },
    ],
  },
  {
    path: '/message-notice',
    redirect: '/notice/notice-list',
  },
  // 每日简报
  {
    path: '/daily-symple-report',
    name: 'DAILY-SYMPLE-REPORT',
    meta: {
      title: '每日简报',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/hotelcem/views/daily-report/index'),
  },
  // 使用条款
  {
    path: '/terms-of-use',
    name: 'TERMS-OF-USE',
    meta: {
      title: '使用条款',
    },
    props: { device: storeCEM.getters.deviceMode },
    component: () => import('@/components/terms-of-use/index'),
  },
]

/**
 * 查找出H5不要的菜单MAP
 * @param {*} asyncRoutes
 * @param {*} device
 * @param {*} map
 * @returns
 */
// export function filterNotH5Menu(asyncRoutes, device, map) {
//   for (const route of asyncRoutes) {
//     if (route.children?.length) {
//       filterNotH5Menu(route.children, device, map)
//     }

//     if (device === 'mobile' && route?.meta?.hideInH5) {
//       map[route.name] = route
//     } else {
//       continue
//     }
//   }
//   return map
// }
